import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { DataSnapshotPages } from "@constants";
import pbiTile from "@public-client/Components/Charts/PBI.Tile.vue";
export default {
  components: {
    pbiTile
  },
  data() {
    return {
      snapShot1_page: DataSnapshotPages.filtered.Gender,
      snapshotPages: DataSnapshotPages.filtered
    };
  },
  computed: {
    loading() {
      return this.$store.state.loading || !this.programs.length;
    },
    cycle() {
      let target = this.$store.getters.cycle;
      return target ? target : {};
    },
    entity() {
      let target = this.$store.getters.entity;
      return target ? target : {};
    },
    entityProgram() {
      let target = this.$store.getters.programCategorySummary;
      if (target.Programs && this.$store.state.programId) {
        target = target.Programs.find(program => program.ProgramId == this.$store.state.programId);
      }
      // TODO: THIS IS A DEFECT. NEED TO SEE IF A SIDE EFFECT FREE EQUIV IS NEEDED OR IF SAFE TO REMOVE.
      // if (target) {
      //     this.$set(target, "PrivateInd", true);
      // }
      return target ? {
        ...target,
        PrivateInd: target.PrivateInd ?? false
      } : {
        ProgramTypes: {},
        PostSecondaryLevels: {},
        Facts: [],
        PrivateInd: false
      };
    },
    programSize() {
      let target = this.$store.getters.programCategorySummary;
      if (!target || !target.AvgCompleters) return "--";
      if (target.AvgCompleters > 1000) return "> 1000";
      if (target.AvgCompleters > 500) return "> 500";
      if (target.AvgCompleters > 200) return "> 200";
      if (target.AvgCompleters > 100) return "> 100";
      if (target.AvgCompleters > 50) return "> 50";
      if (target.AvgCompleters > 25) return "> 25";
      return "0-25";
    },
    programs() {
      let entityProgram = this.$store.getters.entityProgramCategory;
      return entityProgram && entityProgram.Programs ? entityProgram.Programs : [];
    },
    snapShot1_filters() {
      let entityId = this.$store.state.entityId ? [this.$store.state.entityId] : [0];
      let programIds = [0];
      if (this.programs.length) programIds = this.programs.map(p => p.ProgramId);
      let cycleYear = this.cycle.IPPCycleYear;
      if (cycleYear == null) cycleYear = 2022;
      return [{
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Race/Ethnicity Snapshot",
          column: "EntityId"
        },
        operator: "In",
        values: entityId,
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }, {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Race/Ethnicity Snapshot",
          column: "ProgramId"
        },
        operator: "In",
        values: programIds,
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }, {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Race/Ethnicity Snapshot",
          column: "IPPCycleYear"
        },
        operator: "Is",
        values: [cycleYear],
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }, {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Gender Snapshot",
          column: "EntityId"
        },
        operator: "In",
        values: entityId,
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }, {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Gender Snapshot",
          column: "ProgramId"
        },
        operator: "In",
        values: programIds,
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }, {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Gender Snapshot",
          column: "IPPCycleYear"
        },
        operator: "Is",
        values: [cycleYear],
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }, {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Demographic Snapshot",
          column: "EntityId"
        },
        operator: "In",
        values: entityId,
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }, {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Demographic Snapshot",
          column: "ProgramId"
        },
        operator: "In",
        values: programIds,
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }, {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Demographic Snapshot",
          column: "IPPCycleYear"
        },
        operator: "Is",
        values: [cycleYear],
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }];
    },
    snapShot2_filters() {
      let entityId = this.$store.state.entityId ? [this.$store.state.entityId] : [0];
      let programIds = [0];
      if (this.programs.length) programIds = this.programs.map(p => p.ProgramId);
      let cycleYear = this.cycle.IPPCycleYear;
      if (cycleYear == null) cycleYear = 2022;
      return [{
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Trending Enrollment Snapshot",
          column: "EntityId"
        },
        operator: "In",
        values: entityId,
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }, {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Trending Enrollment Snapshot",
          column: "ProgramId"
        },
        operator: "In",
        values: programIds,
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }, {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Trending Enrollment Snapshot",
          column: "IPPCycleYear"
        },
        operator: "Is",
        values: [cycleYear],
        filterType: 1 // pbi.models.FilterType.BasicFilter
      }];
    }
  },
  methods: {
    getDurationDescription(duration) {
      let type = this.$store.state.programTypes.find(y => y.ProgramTypeId === duration.TypeId);
      let postSecondaryLevel = this.$store.state.postSecondaryLevels.find(y => duration.PostSecondaryLevelId === y.PostSecondaryLevelId);
      return (postSecondaryLevel ? postSecondaryLevel.PostSecondaryDescription + ", " : "") + (type ? type.Description : "");
    }
  }
};